import { Spinner } from "./Spinner";
import { Icon, IconColor, IconSize, IconType } from "./icons";

export function IconMessage(props: {
	type: IconType | "spinner",
	message: string,
	size?: IconSize,
	color?: IconColor,
	className?: string,
}) {

	const icon = (props.type === "spinner") ?
		<Spinner size="small" />
		: <Icon type={props.type as IconType} color={props.color} size={props.size ? props.size : "small"} />;


	return (
		<div className={"flex horiz gap-3 padding-3 " + props.className}>
			{icon}
			<span className="font-small">{props.message}</span>
		</div>
	);
}